import * as types from './mutation-types';
import { defaultState } from './state';

const resetState_ = state => {
	Object.assign(state, defaultState);
};
export default {
	resetState_,
	[types.DEFAULT_ASSIGN]: (state, payload) => {
		state[payload.key] = payload.value;
	},
	[types.DELETE_CONTENTS]: (state, payload) => {
		delete state.sqlContent[payload.value];
	},
	[types.ADD_CONTENTS]: (state, payload) => {
		if (!state.sqlContent.map(v => v.sqlId).includes(payload.value.sqlId)) {
			let contents = [...state.sqlContent, payload.value];
			state[payload.key] = contents;
		}
		// if (!state.sqlContent[payload.value.sqlId]) {
		// 	state[payload.key] = { ...state[payload.key], [payload.value.sqlId]: payload.value };
		// }
	},
	[types.ADD_COMPILES]: (state, payload) => {
		state.sqlContent.forEach((row, index) => {
			// console.log('row', row);
			if (row.sqlId === payload.value.sqlId) {
				row['BindSqlText'] = payload.value.sql;
				row['StaticSqlText'] = payload.value.staticSql;
			}
		});

		// if (!state.compileText.map(v => v.sqlId).includes(payload.value.sqlId)) {
		// 	let contents = [...state.compileText, { ...payload.value }];
		// 	state[payload.key] = contents;
		// } else {
		// 	let index = state.compileText.findIndex(row => row.sqlId === payload.value.sqlId);
		// 	state.compileText.splice(index, 1);
		// 	state[payload.key] = [...state.compileText, { ...payload.value }];
		// }
	},
	[types.ADD_LOGS]: (state, payload) => {
		state.sqlContent.map(v => {
			if (v.sqlId === payload.value.sqlId) {
				v['sqlLog'] = payload.value.body;
			}
		});
	},

	[types.TREE_LIST]: (state, payload) => {
		let paths = payload;

		let result = [];
		let level = { result };

		let idx = 1;
		paths.forEach(path => {
			path.sqlId.split('.').reduce((r, name, i, a) => {
				if (!r[name]) {
					r[name] = { result: [] };

					r.result.push({ id: idx++, sqlId: path.sqlId, label: name, children: r[name].result });
				}

				return r[name];
			}, level);
		});

		state.menuTree = result;
	}
};
